/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SortDirection {
    ASC = 'Asc',
    DESC = 'Desc',
}
